
















import Vue from "vue";
import { IOption } from "@web-components/types/Option";

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array as () => IOption[],
      required: true,
    },
  },
});
